
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import ReportsPreviewView from "./reports-preview.html";

angular.module("reports", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('reports', {
                url: "/reports",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                data: { pageTitle: "Informes" }
            })
            .state('reports.preview', {
                url: "/preview",
                controller: "ReportsPreviewCtrl",
                template: ReportsPreviewView,
                data: { pageTitle: "Previsualización" }
            })            
        ;
    }])
;